export const defaultChannelUuids = [
  '2a35b40f-abe4-4129-8294-3014da44569e',
  'fd399355-1640-4221-a126-097f0b8cae26',
]
